interface CreatedSourcesStore {
  get: () => string[];
  set: (next: string[]) => void;
}

let createdSources: string[] = [];

export const createdSourcesStore: CreatedSourcesStore = {
  get: (): string[] => createdSources,
  set: (next: string[]): void => {
    createdSources = next;
  },
};
